import { render } from "./AppNavbar.vue?vue&type=template&id=8aabe10c"
import script from "./AppNavbar.vue?vue&type=script&lang=js"
export * from "./AppNavbar.vue?vue&type=script&lang=js"

import "./AppNavbar.vue?vue&type=style&index=0&id=8aabe10c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__